import { useState, useEffect, useMemo, Suspense } from 'react';
import {
    AppBar, Toolbar, Typography, Button, Card, CardHeader, CardContent, CardActions, Paper, Container, createTheme,
    ThemeProvider
} from "@mui/material";

import {useTranslation} from "react-i18next";

import {Route, Switch, useSearchParams} from "wouter";

import {createAuthClient} from "better-auth/react";

import { jwtClient } from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";
import { anonymousClient } from "better-auth/client/plugins";
import { lastLoginMethodClient } from "better-auth/client/plugins";
import { oauthProviderClient } from "@better-auth/oauth-provider/client";

import Login from "./Login.jsx";
import ResetPassword, {ChangePassword} from "./ResetPassword.jsx";
import Checkout from "./Checkout.jsx";
import Logoff from "./Logoff.jsx";
import Done from "./Done.jsx";
import Pricing from "./Pricing.jsx";
import HeaderControls from "./HeaderControls.jsx";

import {useConfig} from "./configProvider";

const serverUrl = document.location.origin;

export const authClient = createAuthClient({
    baseURL: serverUrl,
  plugins: [
    jwtClient(),
    //polarClient(),
    passkeyClient(),
    anonymousClient(),
    lastLoginMethodClient(),
      oauthProviderClient()
    ]
});

const App = () => {
    return <Suspense fallback={<Loading />}>
                <App1 />
            </Suspense>;
    }
const App1 = () => {
    const {t} = useTranslation();

    const [config, setConfig] = useConfig();

    const [mode, setMode] = useState('light');

    const theme = useMemo(() => createTheme({
                                    palette: {
                                        mode,
                                        },
                                }),
        [mode]);

    const handleToggleColorMode = () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
        }

    useEffect(() => {
        var valid = true;
        
        const getConfig = async () => {
            const rsp = await fetch(document.location.origin + "/config");
            const nextConfig = await rsp.json();
            if (valid) {
                setConfig(nextConfig);
                }
            }
            
        getConfig();
        
        return () => {
            valid = false;
            };
            
        }, []);

    return  <>
                <title>{t("RSJ License Server")}</title>
                <ThemeProvider theme={theme}>

                    <Container component="main" maxWidth="sm" sx={{ minWidth: "800px", minHeight: '100vh', display: 'flex', alignItems: 'center', py: 4 }}>
                        <Card elevation={5} sx={{ width: '100%', borderRadius: 3, overflow: 'visible', position: 'relative' }}>

                            {/* Header Controls (Lang + Dark Mode) */}
                            <HeaderControls toggleColorMode={handleToggleColorMode} />

                            <Switch>
                                <Route path={"/"} component={Main} />
                                <Route path={"/done"} component={Done}/>
                                <Route path={"/pricing"} component={Pricing}/>
                                <Route path={"/resetPassword"} component={ResetPassword} />
                                <Route path={"/changePassword"} component={ChangePassword} />
                                <Route path={"/logoff"} component={Logoff} />
                            </Switch>
                        </Card>
                    </Container>

                </ThemeProvider>
            </>;
    }

const Loading = () => <div>Loading...</div>;

const Main = () => {

    const {data: session} = authClient.useSession();

    return  <>
                {session == null &&
                    <Login/>
                    }

                {session != null &&
                    <Checkout/>
                    }
            </>;
    }

export default App;
